<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1tPuxL/tc-custom/9781504054607.jpg?1699985044880" alt="This image is the cover for the book Blaine McCracken Novels Volume Two, The Blaine McCracken Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blaine McCracken Novels Volume Two, The Blaine McCracken Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>Two knockout thrillers featuring the heroic rogue agent—from the <i>USA Today</i>–bestselling author and “one of the best all-out action writers in the business” (<i>Los Angeles Review of Books</i>).</b><br/>  <br/> “Nobody writes action like Jon Land,” and his Blaine McCracken series blasts the thriller genre to a whole new level (John Lescroart). Collected here are the fourth and fifth adventures of the “no-holds-barred rogue agent” who nukes the rulebook to save the world (<i>Publishers Weekly</i>).<br/>  <br/><i>The Omicron Legion</i>: A mysterious league of elite assassins targets ninety-six of the most powerful people in America, and only McCracken can stop them before the murderers bring the country to its knees in Land’s “first-rate suspense thriller” (<i>Publishers Weekly</i>).<br/>  <br/><i>The Vengeance of the Tau</i>: Far beneath the sands of Alexandria in Egypt, an archaeological team digs deeper than anyone has before, seeking an ancient power older than the pyramids. What they unearth is an evil that threatens the whole world. An insidious secret organization, the Tau, attempts to harness the vicious force as part of a plan for world domination. But they didn’t count on a certain rogue American op.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Land
      </h2>
      
      <p class="authorDescription body article">Jon Land is the <I>USA Today</I>&ndash;bestselling author of <I>The </I><I>Tenth Circle</I>,<I> Pandora&rsquo;s Temple</I> (winner of the 2012 International Book Award and nominated for a 2013 Thriller Award for Best E-Book Original Novel), and five other books featuring Blaine McCracken, Land&rsquo;s iconic series hero, for Open Road Integrated Media. He also pens the critically acclaimed Caitlin Strong series, which includes <I>Strong Rain Falling</I> and <I>Strong Darkness</I>, winners of the USA Best Book Award in 2013 and 2014, in the Mystery and Thriller categories, respectively. Now with thirty-seven books to his credit,&#160;Land will soon be working on a new title for Open Road, in which McCracken teams up with Land&rsquo;s other bestselling series hero, Jared Kimberlain (<I>The Eighth Trumpet </I>and<I> The Ninth Dominion</I>).&#160;Land lives in Providence, Rhode Island, and can be found at jonlandbooks.com and on Twitter with the handle @jondland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1edf22ee